export const CONNECTION_ERROR__TITLE = 'Connection error';
export const SOMETHING_WENT_WRONG__TITLE = 'Something went wrong';
